import {
	Typography,
	Box,
	useTheme,
	FormControlLabel,
	Switch,
	FormControl,
	InputLabel,
	Select,
	Button,
	MenuItem,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { tokens } from "../../theme";
import useHttpService from "../Common/useHttpService";
import Editor from "@monaco-editor/react";

function Setting(props) {
	const [settingsData, setsettingsData] = useState([]);
	const [originalSettingsData, setoriginalSettingsData] = useState([]);
	const [dialogIsOpen, setdialogIsOpen] = useState(false);
	const [dialogData, setdialogData] = useState([]);
	const [fiberColumnSequence, setFiberColumnSequence] = useState("[]");
	const [isFiberEditorOpen, setIsFiberEditorOpen] = useState(false);
	const [tempFiberColumnSequence, setTempFiberColumnSequence] = useState("");
	const [isEditorDirty, setIsEditorDirty] = useState(false);

	const dialogContext = useRef("switches");

	const httpService = useHttpService();
	const theme = useTheme();
	const colors = tokens(theme.palette.mode);

	const apiPathSettings = "/ftth_coverage/settings";
	const apiUrlSettings = new URL(
		process.env.NODE_ENV === "production"
			? process.env.REACT_APP_PROD_API_BASE_PATH + apiPathSettings
			: process.env.REACT_APP_DEV_API_BASE_PATH + apiPathSettings,
		process.env.NODE_ENV === "production"
			? window.location.origin
			: process.env.REACT_APP_DEV_API_BASE_URL
	);

	useEffect(() => {
		httpService.getAPI(apiUrlSettings.href, onSettingsDataReceived);
	}, []);

	const onSettingsDataReceived = (data) => {
		setsettingsData(data);
		setoriginalSettingsData(JSON.parse(JSON.stringify(data)));

		const fiberColSetting = data.find(
			(el) => el.name === "FIBERCOP_COLUMN_SEQUENCE"
		);
		if (fiberColSetting) {
			try {
				const parsed = JSON.parse(fiberColSetting.value);
				const formatted = JSON.stringify(parsed, null, 2);
				setFiberColumnSequence(formatted);
				setTempFiberColumnSequence(formatted);
			} catch {
				setFiberColumnSequence("[]");
				setTempFiberColumnSequence("[]");
			}
		}
	};

	const fromStringToBool = (str) => str === "true";
	const fromBoolToString = (bool) => bool.toString();


	const buildDialogMessages = (context = "all", forceEditorSave = false) => {
		const messages = [];

		if (context === "all" || context === "switches") {
			settingsData.forEach((setting, index) => {
				if (setting.value !== originalSettingsData[index]?.value) {
					switch (setting.name) {
						case "BUSINESS_SIMULATION":
							messages.push("Change the service coverage rules");
							break;
						case "LOCK_ORDER_WORKFLOWS":
							messages.push(
								setting.value === "false"
									? "Activate Order Workflows"
									: "Deactivate Order Workflows"
							);
							break;
						case "LOCK_EVENT_WORKFLOWS":
							messages.push(
								setting.value === "false"
									? "Activate Event Workflows"
									: "Deactivate Event Workflows"
							);
							break;
						case "AGENDA_ENABLED":
							messages.push(
								setting.value === "false" ? "Disable Agenda" : "Enable Agenda"
							);
							break;
						case "CHECK_ITALIA_1G":
							messages.push(
								setting.value === "true"
									? "Enable Italia 1G check"
									: "Disable Italia 1G check"
							);
							break;
						default:
							break;
					}
				}
			});
		}

		if ((context === "all" || context === "editor") && forceEditorSave) {
			messages.push("Update FiberCop Column Sequence");
		}

		setdialogData(messages);
	};

	useEffect(() => {
		if (dialogData.length > 0) setdialogIsOpen(true);
	}, [dialogData]);

	const saveSettingsData = async (context) => {
		const _settingsData = JSON.parse(JSON.stringify(settingsData));
		const promises = [];

		if (context === "editor") {
			try {
				const parsed = JSON.parse(tempFiberColumnSequence);
				const newValue = JSON.stringify(parsed);

				let fiberColSetting = _settingsData.find(
					(el) => el.name === "FIBERCOP_COLUMN_SEQUENCE"
				);
				if (fiberColSetting) {
					fiberColSetting.value = newValue;
				} else {
					fiberColSetting = {
						id: "generated-id-fibercop-column-sequence",
						name: "FIBERCOP_COLUMN_SEQUENCE",
						value: newValue,
					};
					_settingsData.push(fiberColSetting);
				}

				const payload = {
					id: fiberColSetting.id,
					name: fiberColSetting.name,
					value: fiberColSetting.value,
				};
				promises.push(httpService.putAPI(apiUrlSettings.href, payload));
			} catch {
				props.setsnack?.({
					open: true,
					message: "Invalid JSON format in FiberCop Column Sequence",
					status: "error",
				});
				setdialogData([]);
				return;
			}
		}

		if (context === "switches") {
			const switchSettings = settingsData.filter(
				(el) =>
					el.name !== "FIBERCOP_COLUMN_SEQUENCE" &&
					el.name !== "TASK_ID_TO_CLEAR" &&
					originalSettingsData.find((o) => o.name === el.name)?.value !==
						el.value
			);
			switchSettings.forEach((el) =>
				promises.push(httpService.putAPI(apiUrlSettings.href, el))
			);
		}

		try {
			await Promise.all(promises);

			if (context === "editor") {
				const saved = _settingsData.find(
					(el) => el.name === "FIBERCOP_COLUMN_SEQUENCE"
				)?.value;
				setTempFiberColumnSequence(
					saved ? JSON.stringify(JSON.parse(saved), null, 2) : "[]"
				);
			}

			setoriginalSettingsData(JSON.parse(JSON.stringify(_settingsData)));
			setsettingsData(JSON.parse(JSON.stringify(_settingsData)));

			if (context === "editor") {
				setIsFiberEditorOpen(false);
				setIsEditorDirty(false);
			}

			props.setsnack?.({
				open: true,
				message: "Operation successfully completed",
				status: "success",
			});
		} catch (err) {
			console.error(err);
			props.setsnack?.({
				open: true,
				message: "An error occurred while saving!",
				status: "error",
			});
		} finally {
			setdialogData([]); 
		}
	};


	const onSwitchesSaveClick = () => {
		dialogContext.current = "switches";
		buildDialogMessages("switches");
	};
	const onEditorSaveClick = () => {
		try {
			JSON.parse(tempFiberColumnSequence);
			dialogContext.current = "editor";
			buildDialogMessages("editor", true);
		} catch {
			props.setsnack?.({
				open: true,
				message: "Invalid JSON in FiberCop Column Sequence",
				status: "error",
			});
		}
	};

	return (
		<>
			{dialogData.length > 0 && (
				<Dialog
					open={dialogIsOpen}
					onClose={() => setdialogIsOpen(false)}
					maxWidth="xs"
					fullWidth
				>
					<DialogTitle fontWeight="bold" fontSize="14pt">
						Confirmation Alert
					</DialogTitle>
					<DialogContent>
						<DialogContentText
							sx={{
								fontSize: "14px",
								color: "#fff",
								lineHeight: 1.75,
								whiteSpace: "pre-line",
							}}
						>
							{dialogContext.current === "editor" ? (
								<>
									<strong>Warning!</strong> You are about to Implement changes
									that may pose risks and potentially compromise the integrity
									or proper functioning of the coverage system!
									{"\n\n"}Are you sure you want to continue?
								</>
							) : (
								<>
									<strong>Warning!</strong> You are about to:
									<ul style={{ marginTop: 8, marginBottom: 8 }}>
										{dialogData.map((el, idx) => (
											<li key={idx}>{el}</li>
										))}
									</ul>
									Do you want to continue?
								</>
							)}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={() => {
								if (dialogContext.current === "switches") {
									setsettingsData(
										JSON.parse(JSON.stringify(originalSettingsData))
									);
								}
								setdialogIsOpen(false);
								setdialogData([]);
							}}
							variant="contained"
							color="secondary"
						>
							No
						</Button>
						<Button
							variant="contained"
							color="secondary"
							onClick={() => {
								setdialogIsOpen(false);
								saveSettingsData(dialogContext.current);
							}}
							autoFocus
						>
							Yes
						</Button>
					</DialogActions>
				</Dialog>
			)}

			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					width: "100%",
					marginTop: "50px",
				}}
			>
				<Box sx={{ width: "45%", pl: 2 }}>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							marginBottom: "20px",
						}}
					>
						<Typography>Business Simulation</Typography>
						<FormControl>
							<InputLabel shrink id="business-sim-label">
								Business Simulation
							</InputLabel>
							<Select
								labelId="business-sim-label"
								id="business-sim-select"
								value={
									settingsData.length > 0
										? fromBoolToString(
												settingsData.find(
													(el) => el.name === "BUSINESS_SIMULATION"
												)?.value
										  )
										: ""
								}
								label="Business Simulation"
								displayEmpty
								notched
								onChange={(e) => {
									const updated = [...settingsData];
									updated.forEach((el) => {
										if (el.name === "BUSINESS_SIMULATION")
											el.value = fromBoolToString(e.target.value);
									});
									setsettingsData(updated);
								}}
							>
								<MenuItem value={true}>Check Whitelist</MenuItem>
								<MenuItem value={false}>Check Blacklist</MenuItem>
								<MenuItem value="">Passthrough</MenuItem>
							</Select>
						</FormControl>
					</Box>

					{[
						{ label: "Lock Event Workflows", name: "LOCK_EVENT_WORKFLOWS" },
						{ label: "Lock Order Workflows", name: "LOCK_ORDER_WORKFLOWS" },
						{
							label: "Agenda Management Slot Prioritization",
							name: "AGENDA_ENABLED",
						},
						{ label: "Check Italia 1G", name: "CHECK_ITALIA_1G" },
					].map(({ label, name }) => (
						<Box
							key={name}
							sx={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "20px",
							}}
						>
							<Typography>{label}</Typography>
							<FormControl>
								<FormControlLabel
									control={
										<Switch
											name={label}
											color="secondary"
											checked={
												fromStringToBool(
													settingsData.find((el) => el.name === name)?.value
												) || false
											}
											onChange={(e) => {
												const updated = [...settingsData];
												updated.forEach((el) => {
													if (el.name === name)
														el.value = fromBoolToString(e.target.checked);
												});
												setsettingsData(updated);
											}}
										/>
									}
								/>
							</FormControl>
						</Box>
					))}

					<Button
						sx={{ width: "20%", marginTop: "20px" }}
						variant="contained"
						color="secondary"
						onClick={onSwitchesSaveClick}
					>
						Save
					</Button>
				</Box>

				<Box sx={{ width: "40%", ml: 10 }}>
					<Box
						sx={{
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							mb: 1,
						}}
					>
						<Typography variant="h6">FiberCop Column Sequence</Typography>
						{!isFiberEditorOpen && (
							<Button
								size="small"
								variant="contained"
								color="secondary"
								onClick={() => setIsFiberEditorOpen(true)}
							>
								Edit
							</Button>
						)}
					</Box>

					{isFiberEditorOpen && (
						<>
							<Box
								sx={{
									border: "2px solid #ccc",
									borderRadius: "4px",
									overflow: "hidden",
									height: "325px",
									mb: 2,
								}}
							>
								<Editor
									height="100%"
									language="json"
									value={tempFiberColumnSequence}
									onChange={(val) => {
										setTempFiberColumnSequence(val || "[]");
										setIsEditorDirty(true);
									}}
									theme="vs-dark"
									options={{
										wordWrap: "off",
										minimap: { enabled: false },
										formatOnPaste: true,
										formatOnType: true,
										scrollBeyondLastLine: true,
										padding: {
											top: 10,
											bottom: 10,
										},
										roundedSelection: true,
										lineNumbersMinChars: 3,
										renderWhitespace: "boundary",
										scrollbars: {
											useShadows: true,
										},
										scrollbar: {
											verticalScrollbarSize: 8,
											horizontalScrollbarSize: 8,
										},
										fontSize: 12,
										fontFamily: `"Fira Code", monospace`,
										tabSize: 2,
										wordBasedSuggestions: false,
										autoClosingBrackets: "always",
									}}
								/>
							</Box>

							<Box sx={{ display: "flex", gap: 2 }}>
								<Button
									variant="contained"
									color="secondary"
									disabled={!isEditorDirty}
									onClick={onEditorSaveClick}
								>
									Save
								</Button>
								<Button
									variant="outlined"
									color="secondary"
									onClick={() => {
										const fiberColSetting = originalSettingsData.find(
											(el) => el.name === "FIBERCOP_COLUMN_SEQUENCE"
										);
										setTempFiberColumnSequence(
											fiberColSetting
												? JSON.stringify(
														JSON.parse(fiberColSetting.value),
														null,
														2
												  )
												: "[]"
										);
										setIsFiberEditorOpen(false);
										setIsEditorDirty(false);
									}}
								>
									Cancel
								</Button>
							</Box>
						</>
					)}
				</Box>
			</Box>
		</>
	);
}

export default Setting;
